import React from 'react';
import styles from './CustomCardInfos.module.css';
import CustomImage from '../customImage/CustomImage';
import CustomTextMarkdown from '../customTextMarkdown/customTextMarkdown';
import CustomButton from '../customButton/CustomButton';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow_right.svg';
import colors from '../../styles/colors';

type CustomCardInfoProps = {
    iconUrl: string;
    title: string;
    content: string;
    iconSize?: string;
    className?: any;
    cardType?: string;
    btnValue?: string;
    btnOnClick?: () => void;
}

const CustomCardInfo = (props: CustomCardInfoProps) => {

    const getCardClass = () => {
        switch(props.cardType) {
            case 'bigIconCard':
                return [styles.bigIconCard, styles.bigIconCard_icon]
            default:
                return [styles.card, styles.card_icon]
        }   
    }

    return (
        <div className={`${props.className} ${getCardClass()[0]}`} onClick={props.btnOnClick}>
            <div>
                <div className={getCardClass()[1]} style={(props.iconSize && {width: props.iconSize}) || {}}>
                    <CustomImage src={props.iconUrl} alt="" />
                </div>
            </div>

            <div>
                <CustomTextMarkdown components={{ p : 'h3' }} className={styles.card_title}>{props.title}</CustomTextMarkdown>
                <CustomTextMarkdown>{props.content}</CustomTextMarkdown>
            </div>

            { props.btnValue &&
                <CustomButton
                    buttonType="text"
                    color={colors.darkBlue}
                    endIcon={<ArrowRight />}>
                    {props.btnValue}
                </CustomButton>
            }
        </div>
    );
}

export default CustomCardInfo;